import { convertToAttr } from "./convertToAttr";
export var marshall = function (data, options) { return convertToAttr(data, options).M; };
